import React, { useState } from "react";
import { BackTop, Tabs } from "antd";
import "../utils/cgu.css";
import logo from "../../../assets/images/Paxity.png";
import { AnimatePresence, motion } from "framer-motion";

import ConditionUtilisation from "./tab/ConditionUtilisation";
import ConditionVente from "./tab/ConditionVente";
import MentionsLegales from "./tab/MentionsLegales";
import successAnimv from "../../../assets/animations/successV.json";
import Lottie from "lottie-react";

const { TabPane } = Tabs;

const tabData = [
  { key: "1", title: "Conditions d'utilisation", content: <ConditionUtilisation /> },
  { key: "2", title: "Conditions de vente", content: <ConditionVente /> },
  { key: "3", title: "Mentions légales", content: <MentionsLegales /> },
];

const CGU = () => {
  const [activeKey, setActiveKey] = useState("1");
  const active = tabData.find((t) => t.key === activeKey);

  return (
    <div className="cgu-container">
        <div className="cgu-header">
            <img src={logo} alt="Logo" className="cgu-logo" />
            <div className="cgu-register">
                <span>Je suis d'avis,</span>
                <a href="/register-merchant">Je continue mon inscription</a>
                <div className="lottie-container">
                    <Lottie
                        animationData={successAnimv}
                        loop
                        autoplay
                    />
                </div>
            </div>
        </div>

        <div className="cgu-title centered-title">
          Les politiques de confidentialité et les conditions d'utilisation PAXITY
        </div>


      <div className="cgu-tabs-wrapper mt-4">
        <Tabs
          tabPosition="left"
          className="cgu-tabs"
          activeKey={activeKey}
          onChange={setActiveKey}
        >
          {tabData.map((t) => (
            <TabPane
              tab={
                <><hr />
                  <div className="cgu-tab-title">{t.title}</div>
                  
                </>
              }
              key={t.key}
            />
          ))}
        </Tabs>

        <div className="cgu-content-wrapper">
          <AnimatePresence exitBeforeEnter>
            <motion.div
              key={activeKey}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
              className="cgu-content"
            >
              {active?.content}
            </motion.div>
          </AnimatePresence>
        </div>
        <BackTop visibilityHeight={800} duration={100} title="Revenir en haut">
            <div className="custom-backtop">↑</div>
        </BackTop>
      </div>
    </div>
  );
};

export default CGU;
